import * as aTypes from '../action-types'
import * as mTypes from '../mutation-types'
import api from '../../api'
import { route, router } from '../../router'
import { networkError, getLocalStorageItem, setLocalStorageItem } from '../../utils'

const genVerifCodeImageRandom = () => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)

const PHONE_KEY = 'lingxi-mobile-storage-login-phone'
const EMAIL_KEY = 'lingxi-mobile-storage-login-email'
const storedPhone = getLocalStorageItem(PHONE_KEY)
const storedEmail = getLocalStorageItem(EMAIL_KEY)

const state = {
  phone: storedPhone || '',
  robotVerifCode: '',
  smsVerifCode: '',

  verifiedPhone: '',

  phoneError: '',
  robotVerifCodeError: '',
  smsVerifCodeError: '',

  robotVerifCodeImageRandom: genVerifCodeImageRandom(),

  teamId: null,

  teamName: '',
  teamDomain: '',
  adminName: '',
  regPassword: '',
  regPasswordConfirm: '',

  teamNameError: '',
  teamDomainError: '',
  adminNameError: '',
  regPasswordError: '',
  regPasswordConfirmError: '',

  time: {
    login: 0,
    reg: 0
  }, // 短信计时

  newPassword: '',
  newPasswordConfirm: '',
  newPasswordError: '',
  newPasswordConfirmError: '',

  email: storedEmail || '',
  loginPassword: '',
  emailError: '',
  loginPasswordError: '',
  loginByMail: false,
  agreed: true,

  orgs: [],

  isRegister: false,

  registerTeamCount: ''
}

const verifyRobotCode = (commit, code, success, loadingKey) => {
  if (code) {
    api.login.checkRobotCaptcha({
      success (res) {
        commit(mTypes.GEETEST_SET_VALIDATE, code)
        commit(mTypes.SET_LOADING, { key: loadingKey, loading: false })
        if (success) {
          success(res)
        }
      },
      fail (res) {
        commit(mTypes.LOGIN_UPDATE, { robotVerifCodeError: res.body.message }) // 错误
        commit(mTypes.SET_LOADING, { key: loadingKey, loading: false })
      }
    }, code)
  } else {
    commit(mTypes.LOGIN_UPDATE, { robotVerifCodeError: '验证码不正确' }) // 错误
    commit(mTypes.SET_LOADING, { key: loadingKey, loading: false })
  }
}

const beginSmsInterval = (commit, key, time = 60000) => {
  commit(mTypes.LOGIN_TIME_SMS, { key, time })
  const intervalID = window.setInterval(() => {
    time -= 1000
    if (time <= 0) {
      time = 0
      clearInterval(intervalID)
    }
    commit(mTypes.LOGIN_TIME_SMS, { key, time })
  }, 1000)
}

const smsCaptchaCallback = (commit, key, phone) => {
  return {
    success (res) {
      // commit(mTypes.LOGIN_REFRESH_CAPTCHA)
      beginSmsInterval(commit, key)
      // 记录验证的手机号 防止用户在页面跳转前修改手机号
      commit(mTypes.LOGIN_UPDATE, { verifiedPhone: phone })
      commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_RQST_SMS_VALIDATION, loading: false })
    },
    fail (res) {
      // commit(mTypes.LOGIN_REFRESH_CAPTCHA)
      commit(mTypes.LOGIN_UPDATE, { phoneError: res.body.message })
      commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_RQST_SMS_VALIDATION, loading: false })
    }
  }
}

/**
 * loginCallback generator
 * @param {string} loginByMail - change store.loginByMail true or false
 */
const loginCallback = (commit, loginByMail, loadingKey) => {
  return {
    success (res) {
      if (res.status === 202) {
        // login success
        route.authenticated = true
        router.push({ name: 'dashboard' })
        commit(mTypes.LOGIN_CLEAR_STATE)
      } else {
        if (res.body.map) {
          const orgs = res.body.map(org => {
            return {
              id: org.id,
              name: org.name,
              domain: org.domain
            }
          })
          commit(mTypes.LOGIN_UPDATE, { orgs, loginByMail })
          router.push({ name: 'login-org' })
        } else {
          networkError(commit)
        }
      }
      commit(mTypes.SET_LOADING, { key: loadingKey, loading: false })
    },
    fail (res) {
      // 不太好...
      if (res.body.message) {
        commit(mTypes.LOGIN_UPDATE, { smsVerifCodeError: res.body.message }) // 错误
      } else if (res.body.credential) {
        commit(mTypes.LOGIN_UPDATE, { loginPasswordError: res.body.credential[0] })
      }
      commit(mTypes.SET_LOADING, { key: loadingKey, loading: false })
    }
  }
}

const actions = {
  [aTypes.LOGIN_WITH_PHONE] ({ commit }, { phoneNumber, smsCaptcha, teamId }) {
    commit(mTypes.SET_LOADING, {
      key: aTypes.LOGIN_WITH_PHONE,
      loading: true
    })
    api.login.login(
      // commit(mTypes.SET_REGISTER_STATUS, { status: false })
      loginCallback(commit, false, aTypes.LOGIN_WITH_PHONE), {
        phoneNumber,
        smsCaptcha,
        teamId
      }
    )
  },
  [aTypes.REGISTER_TEAM_COUNT] ({ commit }) {
    api.login.getRegisterTeamCount({
      success (res) {
        commit(mTypes.REGISTER_TEAM_COUNT, { registerTeamCount: res.body.count })
      },
      fail () {
        commit(mTypes.REGISTER_TEAM_COUNT, { registerTeamCount: 90000 })
      }
    })
  },
  [aTypes.LOGIN_WITH_EMAIL] ({ commit }, { mail, password, teamId }) {
    const mailRe = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    if (!mailRe.test(mail)) {
      commit(mTypes.LOGIN_UPDATE, { emailError: '邮箱格式不正确' })
    } else {
      commit(mTypes.SET_LOADING, {
        key: aTypes.LOGIN_WITH_EMAIL,
        loading: true
      })
      api.login.loginByMail(
        loginCallback(commit, true, aTypes.LOGIN_WITH_EMAIL), {
          mail,
          password,
          teamId
        }
      )
    }
  },

  [aTypes.LOGIN_SUBMIT_ROBOT_VERIF_CODE] ({ commit }, code) {
    commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_SUBMIT_ROBOT_VERIF_CODE, loading: true })
    verifyRobotCode(commit, code, null, aTypes.LOGIN_SUBMIT_ROBOT_VERIF_CODE)
  },

  [aTypes.LOGIN_GET_SMS_LEFT_TIME] ({ commit }) {
    const left = window.X.time.mobile_captcha_freedom_left
    if (left) {
      beginSmsInterval(commit, 'login', left * 1000)
    }
  },

  /**
   * RQST SMS VALIDATION
   * @param {string} key - from 'login' or 'reg'?
   */
  [aTypes.LOGIN_RQST_SMS_VALIDATION] ({ commit }, { key, phone, code, smsType }) {
    commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_RQST_SMS_VALIDATION, loading: true })
    commit(mTypes.LOGIN_UPDATE, { phoneError: '' })
    verifyRobotCode(commit, code, () => {
      switch (key) {
        case 'login':
          commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_RQST_SMS_VALIDATION, loading: true }) // verifyRobotCode 成功 loading 被设置为 false，但是并未完成，这里再次设置为 true
          api.login.getSmsCaptchaLogin(smsCaptchaCallback(commit, key, phone), phone, smsType, code)
          break
        case 'reg':
          commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_RQST_SMS_VALIDATION, loading: true }) // verifyRobotCode 成功 loading 被设置为 false，但是并未完成，这里再次设置为 true
          api.login.getSmsCaptchaReg(smsCaptchaCallback(commit, key, phone), phone, smsType, code)
          break
      }
    }, aTypes.LOGIN_RQST_SMS_VALIDATION)
  },

  [aTypes.LOGIN_SMS_VALIDATE] ({ commit }, { type, smsCaptcha }) {
    commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_SMS_VALIDATE, loading: true })
    let cb = {}
    switch (type) {
      case 'login':
        cb = loginCallback(commit, false, aTypes.LOGIN_SMS_VALIDATE)
        break
      case 'register':
        cb = {
          success (res) {
            router.push({ name: 'register2' }) // TODO: 修改注册时注意下
            commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_SMS_VALIDATE, loading: false })
          },
          fail (res) {
            commit(mTypes.LOGIN_UPDATE, { smsVerifCodeError: res.body.message }) // '错误'
            commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_SMS_VALIDATE, loading: false })
          }
        }
        break
    }
    api.login.checkSmsCaptcha(cb, {
      type, smsCaptcha
    })
  },

  [aTypes.LOGIN_REG_TEAM] ({ commit }, { email, smsCaptcha, mobile, name, username, password, passwordConfirm }) {
    commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_REG_TEAM, loading: true })
    api.login.register({
      success (res) {
        commit(mTypes.SET_REGISTER_STATUS, { status: true })
        loginCallback(commit, false).success(res) // as login success
        commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_REG_TEAM, loading: false })
      },
      fail (res) {
        const map = {
          emailError: 'email',
          smsVerifCodeError: 'sms_captcha',
          teamNameError: 'name',
          teamDomainError: 'subdomain',
          regPasswordError: 'password',
          regPasswordConfirmError: 'password_confirmation'
        }
        for (const key in map) {
          const keyFromServer = map[key]
          if (res.body.hasOwnProperty(keyFromServer)) {
            const payload = { [key]: res.body[keyFromServer][0] }
            commit(mTypes.LOGIN_UPDATE, payload)
          }
        }
        commit(mTypes.SET_LOADING, { key: aTypes.LOGIN_REG_TEAM, loading: false })
      }
    }, {
      email, smsCaptcha, mobile, name, username, password, passwordConfirm
    })
  },

  [aTypes.LOGOUT] ({ commit }) {
    commit(mTypes.SET_LOADING, { key: aTypes.LOGOUT, loading: true })
    api.login.logout({
      success (res) {
        route.authenticated = false
        router.push({ name: 'login' })

        commit(mTypes.SET_LOADED_OF_CONTACT_LIST, false)
        commit(mTypes.SET_LOADED_OF_FORM_LIST, false)
        commit(mTypes.SET_LOADED_OF_CF_LIST, false)
        commit(mTypes.SET_LOADED_OF_ACTIVITY_LIST, false)
        commit(mTypes.SET_LOADED_ID_OF_CONTACT_CONTACT_FORMFILL, null)
        commit(mTypes.SET_LOADED_ID_OF_CONTACT_CONTACT_SIGNUP, null)
        commit(mTypes.SET_LOADED_ID_OF_CONTACT_CONTACT_DONATE, null)
        commit(mTypes.SET_LOADED_ID_OF_CONTACT_TAGGED_LIST, { roleId: null, tagId: null })
        commit(mTypes.SET_LOADED_ID_OF_FORM_FEEDBACK, null)
        commit(mTypes.SET_LOADED_ID_OF_CF_FEEDBACK, null)

        commit(mTypes.SET_LOADING, { key: aTypes.LOGOUT, loading: false })
      },
      commit
    })
  },

  [aTypes.SAVE_LX_PASSWORD] ({ commit }, { body }) {
    api.login.saveLxpwd(body, {
      success: res => { commit(mTypes.SET_REGISTER_STATUS, { status: false }) },
      fail: res => {
        const message = res.body.message
        commit(mTypes.SET_DIALOG_HTML, message)
      }
    })
  }
}

const mutations = {
  [mTypes.LOGIN_UPDATE] (state, payload) {
    for (const key in payload) {
      if (state.hasOwnProperty(key)) {
        state[key] = payload[key]
        switch (key) {
          case 'phone':
            setLocalStorageItem(PHONE_KEY, state[key])
            break
          case 'email':
            setLocalStorageItem(EMAIL_KEY, state[key])
            break
        }
      }
    }
  },
  [mTypes.REGISTER_TEAM_COUNT] (state, payload) {
    state.registerTeamCount = payload.registerTeamCount
  },
  [mTypes.LOGIN_CLEAR_PASSWORD] (state) {
    state.regPassword = ''
    state.regPasswordConfirm = ''
    state.newPassword = ''
    state.newPasswordConfirm = ''
    state.loginPassword = ''
  },
  [mTypes.LOGIN_CLEAR_VERIF_CODE] (state) {
    state.robotVerifCode = ''
    state.smsVerifCode = ''
    state.verifiedPhone = ''
  },
  [mTypes.LOGIN_TIME_SMS] (state, { key, time }) {
    state.time[key] = time

    // 登录注册用了不同的 key，可服务器上是一个时间
    for (const k in state.time) {
      state.time[k] = time
    }
  },
  [mTypes.LOGIN_REFRESH_CAPTCHA] (state) {
    state.robotVerifCodeImageRandom = genVerifCodeImageRandom()
  },
  [mTypes.LOGIN_CLEAR_STATE] (state) {
    // state.phone = ''
    state.verifiedPhone = ''
    state.robotVerifCode = ''
    state.smsVerifCode = ''

    state.phoneError = ''
    state.robotVerifCodeError = ''
    state.smsVerifCodeError = ''

    state.robotVerifCodeImageRandom = genVerifCodeImageRandom()

    state.teamId = null

    state.teamName = ''
    state.teamDomain = ''
    state.adminName = ''
    state.regPassword = ''
    state.regPasswordConfirm = ''

    state.teamNameError = ''
    state.teamDomainError = ''
    state.adminNameError = ''
    state.regPasswordError = ''
    state.regPasswordConfirmError = ''

    state.newPassword = ''
    state.newPasswordConfirm = ''
    state.newPasswordError = ''
    state.newPasswordConfirmError = ''

    // state.email = ''
    state.loginPassword = ''
    state.emailError = ''
    state.loginPasswordError = ''

    state.orgs = []
  },

  [mTypes.SET_REGISTER_STATUS] (state, { status }) {
    state.isRegister = status
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js